var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as jwt_decode from 'jwt-decode';
import { zip } from 'rxjs';
import { DataService } from './user-detail.service';
import { LoginService } from './login/shared/login.service';
import { StaffService } from './shared/services/staff.service';
import { environment } from './../environments/environment';
var AppInitService = /** @class */ (function () {
    function AppInitService(dataService, loginService, staffService) {
        this.dataService = dataService;
        this.loginService = loginService;
        this.staffService = staffService;
        this.authURL = environment.AUTH_URL + "/home?action=issue&redirectUrl=" + environment.REDIRECT_URL + "&appName=attendance";
    }
    AppInitService.prototype.Init = function () {
        var _this = this;
        console.log('AMS init service');
        // create iframe for login server
        var newIframe = document.createElement('IFRAME');
        newIframe.id = 'login-system';
        newIframe.style.display = "none";
        newIframe.src = environment.AUTH_URL + "/standby";
        document.body.appendChild(newIframe);
        return new Promise(function (resolve, reject) {
            // when iframe is finish loading
            newIframe.onload = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var token;
                var _this = this;
                return __generator(this, function (_a) {
                    token = localStorage.getItem('access_token');
                    if (!token) {
                        setTimeout(function () { resolve(); }, 50);
                        return [2 /*return*/];
                    }
                    // let res = await this.loginService.validateToken().toPromise();
                    this.loginService.validateToken().subscribe(function (res) {
                        if (!res.data && res.message == '401') {
                            localStorage.removeItem('access_token');
                            resolve();
                        }
                        else {
                            var data = jwt_decode(token);
                            var staffId = data._id;
                            zip(_this.staffService.getStaffById(staffId), _this.loginService.getAttendanceSetting(staffId)).subscribe(function (res) {
                                _this.dataService.setStaffInfo = res[0].data;
                                _this.dataService.setIndividualSettings = res[1];
                                // if there's a settings returned, set hasSettings.
                                if (res[1]) {
                                    _this.dataService.setHasSettings = true;
                                }
                                resolve();
                            });
                        }
                    });
                    return [2 /*return*/];
                });
            }); };
        });
    };
    return AppInitService;
}());
export { AppInitService };
